webpackJsonp([25],{

/***/ 154:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return MediaGallery; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_immutable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__icon_button__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_intl__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__is_mobile__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__initial_state__ = __webpack_require__(12);





var _class, _temp2, _class2, _class3, _temp4;










var messages = Object(__WEBPACK_IMPORTED_MODULE_7_react_intl__["f" /* defineMessages */])({
  toggle_visible: {
    'id': 'media_gallery.toggle_visible',
    'defaultMessage': 'Toggle visibility'
  }
});

var Item = (_temp2 = _class = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Item, _React$PureComponent);

  function Item() {
    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Item);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.handleMouseEnter = function (e) {
      if (_this.hoverToPlay()) {
        e.target.play();
      }
    }, _this.handleMouseLeave = function (e) {
      if (_this.hoverToPlay()) {
        e.target.pause();
        e.target.currentTime = 0;
      }
    }, _this.handleClick = function (e) {
      var _this$props = _this.props,
          index = _this$props.index,
          onClick = _this$props.onClick;


      if (e.button === 0) {
        e.preventDefault();
        onClick(index);
      }

      e.stopPropagation();
    }, _temp), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  Item.prototype.hoverToPlay = function hoverToPlay() {
    var attachment = this.props.attachment;

    return !__WEBPACK_IMPORTED_MODULE_10__initial_state__["a" /* autoPlayGif */] && attachment.get('type') === 'gifv';
  };

  Item.prototype.render = function render() {
    var _props = this.props,
        attachment = _props.attachment,
        index = _props.index,
        size = _props.size,
        standalone = _props.standalone;


    var width = 50;
    var height = 100;
    var top = 'auto';
    var left = 'auto';
    var bottom = 'auto';
    var right = 'auto';

    if (size === 1) {
      width = 100;
    }

    if (size === 4 || size === 3 && index > 0) {
      height = 50;
    }

    if (size === 2) {
      if (index === 0) {
        right = '2px';
      } else {
        left = '2px';
      }
    } else if (size === 3) {
      if (index === 0) {
        right = '2px';
      } else if (index > 0) {
        left = '2px';
      }

      if (index === 1) {
        bottom = '2px';
      } else if (index > 1) {
        top = '2px';
      }
    } else if (size === 4) {
      if (index === 0 || index === 2) {
        right = '2px';
      }

      if (index === 1 || index === 3) {
        left = '2px';
      }

      if (index < 2) {
        bottom = '2px';
      } else {
        top = '2px';
      }
    }

    var thumbnail = '';

    if (attachment.get('type') === 'image') {
      var previewUrl = attachment.get('preview_url');
      var previewWidth = attachment.getIn(['meta', 'small', 'width']);

      var originalUrl = attachment.get('url');
      var originalWidth = attachment.getIn(['meta', 'original', 'width']);

      var hasSize = typeof originalWidth === 'number' && typeof previewWidth === 'number';

      var srcSet = hasSize ? originalUrl + ' ' + originalWidth + 'w, ' + previewUrl + ' ' + previewWidth + 'w' : null;
      var sizes = hasSize ? '(min-width: 1025px) ' + 320 * (width / 100) + 'px, ' + width + 'vw' : null;

      var focusX = attachment.getIn(['meta', 'focus', 'x']) || 0;
      var focusY = attachment.getIn(['meta', 'focus', 'y']) || 0;
      var x = (focusX / 2 + .5) * 100;
      var y = (focusY / -2 + .5) * 100;

      thumbnail = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('a', {
        className: 'media-gallery__item-thumbnail',
        href: attachment.get('remote_url') || originalUrl,
        onClick: this.handleClick,
        target: '_blank'
      }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('img', {
        src: previewUrl,
        srcSet: srcSet,
        sizes: sizes,
        alt: attachment.get('description'),
        title: attachment.get('description'),
        style: { objectPosition: x + '% ' + y + '%' }
      }));
    } else if (attachment.get('type') === 'gifv') {
      var autoPlay = !Object(__WEBPACK_IMPORTED_MODULE_8__is_mobile__["a" /* isIOS */])() && __WEBPACK_IMPORTED_MODULE_10__initial_state__["a" /* autoPlayGif */];

      thumbnail = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {
        className: __WEBPACK_IMPORTED_MODULE_9_classnames___default()('media-gallery__gifv', { autoplay: autoPlay })
      }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('video', {
        className: 'media-gallery__item-gifv-thumbnail',
        'aria-label': attachment.get('description'),
        role: 'application',
        src: attachment.get('url'),
        onClick: this.handleClick,
        onMouseEnter: this.handleMouseEnter,
        onMouseLeave: this.handleMouseLeave,
        autoPlay: autoPlay,
        loop: true,
        muted: true
      }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('span', {
        className: 'media-gallery__gifv__label'
      }, void 0, 'GIF'));
    }

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {
      className: __WEBPACK_IMPORTED_MODULE_9_classnames___default()('media-gallery__item', { standalone: standalone }),
      style: { left: left, top: top, right: right, bottom: bottom, width: width + '%', height: height + '%' }
    }, attachment.get('id'), thumbnail);
  };

  return Item;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.PureComponent), _class.defaultProps = {
  standalone: false,
  index: 0,
  size: 1
}, _temp2);

var MediaGallery = Object(__WEBPACK_IMPORTED_MODULE_7_react_intl__["g" /* injectIntl */])(_class2 = (_temp4 = _class3 = function (_React$PureComponent2) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(MediaGallery, _React$PureComponent2);

  function MediaGallery() {
    var _temp3, _this2, _ret2;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, MediaGallery);

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _ret2 = (_temp3 = (_this2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$PureComponent2.call.apply(_React$PureComponent2, [this].concat(args))), _this2), _this2.state = {
      visible: !_this2.props.sensitive || __WEBPACK_IMPORTED_MODULE_10__initial_state__["f" /* displaySensitiveMedia */]
    }, _this2.handleOpen = function () {
      _this2.setState({ visible: !_this2.state.visible });
    }, _this2.handleClick = function (index) {
      _this2.props.onOpenMedia(_this2.props.media, index);
    }, _this2.handleRef = function (node) {
      if (node /*&& this.isStandaloneEligible()*/) {
          // offsetWidth triggers a layout, so only calculate when we need to
          _this2.setState({
            width: node.offsetWidth
          });
        }
    }, _temp3), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(_this2, _ret2);
  }

  MediaGallery.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_5_immutable__["is"])(nextProps.media, this.props.media)) {
      this.setState({ visible: !nextProps.sensitive });
    }
  };

  MediaGallery.prototype.isStandaloneEligible = function isStandaloneEligible() {
    var _props2 = this.props,
        media = _props2.media,
        standalone = _props2.standalone;

    return standalone && media.size === 1 && media.getIn([0, 'meta', 'small', 'aspect']);
  };

  MediaGallery.prototype.render = function render() {
    var _this3 = this;

    var _props3 = this.props,
        media = _props3.media,
        intl = _props3.intl,
        sensitive = _props3.sensitive,
        height = _props3.height;
    var _state = this.state,
        width = _state.width,
        visible = _state.visible;


    var children = void 0;

    var style = {};

    if (this.isStandaloneEligible()) {
      if (width) {
        style.height = width / this.props.media.getIn([0, 'meta', 'small', 'aspect']);
      }
    } else if (width) {
      style.height = width / (16 / 9);
    } else {
      style.height = height;
    }

    if (!visible) {
      var warning = void 0;

      if (sensitive) {
        warning = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_7_react_intl__["b" /* FormattedMessage */], {
          id: 'status.sensitive_warning',
          defaultMessage: 'Sensitive content'
        });
      } else {
        warning = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_7_react_intl__["b" /* FormattedMessage */], {
          id: 'status.media_hidden',
          defaultMessage: 'Media hidden'
        });
      }

      children = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        'button',
        { type: 'button', className: 'media-spoiler', onClick: this.handleOpen, style: style, ref: this.handleRef },
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('span', {
          className: 'media-spoiler__warning'
        }, void 0, warning),
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('span', {
          className: 'media-spoiler__trigger'
        }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_7_react_intl__["b" /* FormattedMessage */], {
          id: 'status.sensitive_toggle',
          defaultMessage: 'Click to view'
        }))
      );
    } else {
      var size = media.take(4).size;

      if (this.isStandaloneEligible()) {
        children = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(Item, {
          standalone: true,
          onClick: this.handleClick,
          attachment: media.get(0)
        });
      } else {
        children = media.take(4).map(function (attachment, i) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(Item, {
            onClick: _this3.handleClick,
            attachment: attachment,
            index: i,
            size: size
          }, attachment.get('id'));
        });
      }
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      'div',
      { className: 'media-gallery', style: style, ref: this.handleRef },
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {
        className: __WEBPACK_IMPORTED_MODULE_9_classnames___default()('spoiler-button', { 'spoiler-button--visible': visible })
      }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_6__icon_button__["a" /* default */], {
        title: intl.formatMessage(messages.toggle_visible),
        icon: visible ? 'eye' : 'eye-slash',
        overlay: true,
        onClick: this.handleOpen
      })),
      children
    );
  };

  return MediaGallery;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.PureComponent), _class3.defaultProps = {
  standalone: false
}, _temp4)) || _class2;



/***/ })

});


// WEBPACK FOOTER //
// status/media_gallery.js